export default "__VITE_PUBLIC_ASSET__a4b52829__"